__turbopack_context__.v({
  "hero": "LSingleColumn-module__O8goWa__hero",
  "heroLarge": "LSingleColumn-module__O8goWa__heroLarge",
  "heroSmallBottom": "LSingleColumn-module__O8goWa__heroSmallBottom",
  "heroSmallTop": "LSingleColumn-module__O8goWa__heroSmallTop",
  "main": "LSingleColumn-module__O8goWa__main",
  "root": "LSingleColumn-module__O8goWa__root",
});
